<script>
import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Utils from "@/common/Utils";
import Constants from "@/common/Constants";
import GenericCustomAutocompleteV2 from "@/components/generic/GenericCustomAutocompleteV2"
import GenericDataTable from "@/components/generic/GenericDataTable"
import config from '@/common/genericPanelConf';
import Service from '@/services/fiscal-notification'

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: { GenericCustomAutocompleteV2, GenericDataTable },
    data(){
        return{
            submitted: false,
            filters: {
                dateFrom: Utils.formatDatePlusDays(new Date(), -90),
                dateTo: Utils.formatDatePlusDays(new Date(), 0),
                family: null
            },
            configurationGas: {},
            configurationATZ: {},
            configurationBTZ: {}
        }
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'versalisRegister.product_movements_page_title');
    },
    validations(){
        return {
            filters: {
                dateFrom: {required},
                dateTo: {required},
                family: {required}
            }
        }
    },
    created(){
        this.configurationGas = config.getConfiguration('VersalisMovementsGas');
        this.configurationATZ = config.getConfiguration('VersalisMovementsATZ');
        this.configurationBTZ = config.getConfiguration('VersalisMovementsBTZ');
    },
    computed: {
        constants: () => Constants,
        families(){
            return [
                {
                    label: 'GAS',
                    value: 'GAS'
                },
                {
                    label: 'Residui Oleosi BTZ',
                    value: 'BTZ'
                },
                {
                    label: 'Residui Oleosi ATZ',
                    value: 'ATZ'
                }
            ]
        }
    },
    methods: {
        load(valid){
            this.submitted = true;

            if (!valid){
                return;
            }

            let body = [];
            body.push({
                operator: '>=',
                value: this.filters.dateFrom,
                property: 'DATA_DI_RIFERIMENTO',
                propName: 'dateFrom'
            });

            body.push({
                operator: '<=',
                value: Utils.formatEndDate(this.filters.dateTo),
                property: 'DATA_DI_RIFERIMENTO',
                propName: 'dateTo'
            });

            if(this.filters.family == 'GAS'){
                this.$refs.gasGrid.filterFromView(body);
            }
            if(this.filters.family == 'ATZ'){
                this.$refs.atzGrid.filterFromView(body);
            }
            if(this.filters.family == 'BTZ'){
                this.$refs.btzGrid.filterFromView(body);
            }
        },
        dowloadExcel(){
            this.$store.dispatch("generic/setLoading", true);
            let filters = {
                from: Utils.formatDateForAPIWithTime(Utils.formatDatePlusDays(this.filters.dateFrom, 0)), //Utils.formatDateForAPIWithTime(this.filters.from),
                to: Utils.formatDateForAPIWithTime(Utils.formatEndDate(this.filters.dateTo)),
                family: this.filters.family
            }
            Service.versalisMovementExcel(filters, response => {
                
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    let fileName = "Report.xlsx";
                    fileLink.setAttribute('download',fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        }
    }
}

</script>

<template>
    <main>
        <div class="formgrid grid">
            
            <div class="col-12 lg:col-2 field">
                <label for="from" :class="{'p-error':v$.filters.dateFrom.$invalid && submitted}">{{$t('from')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dateFrom.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateFrom"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dateFrom.$invalid && submitted) || v$.filters.dateFrom.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dateFrom.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="to" :class="{'p-error':v$.filters.dateTo.$invalid && submitted}">{{$t('to')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.dateTo.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.dateTo"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.dateTo.$invalid && submitted) || v$.filters.dateTo.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.dateTo.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="familyPool" :class="{'p-error':v$.filters.family.$invalid && submitted}">{{$t('VersalisMovements.family')}}</label>
                <GenericCustomAutocompleteV2
                    :class="{'p-invalid':v$.filters.family.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    v-model="filters.family"
                    :staticOptions="families"
                    name="versalis-product-families" 
                    :format="{label: 'label', value: 'value' }" />
                <div v-if="(v$.filters.family.$invalid && submitted) || v$.filters.family.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.family.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-4 my-5">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="p-button-sm m-1" @click="load(!v$.$invalid)"/>
                <!-- <ResponsiveButton :label="$t('tankOperations.btn.addOperation')" :disabled="!uiPermissions('tankOperationsAddButton').isEnabled" icon="pi pi-plus" class="p-button-sm p-button-outlined m-1" @click="addOperation"/> -->
                <!-- <ResponsiveButton :label="$t('tankOperations.btn.updateOperation')" icon="pi pi-pencil" class="p-button-sm p-button-outlined m-1" @click="updateOperation" :disabled="!uiPermissions('tankOperationsEditButton').isEnabled || !selectedItem"/> -->
                <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" @click="dowloadExcel"/>
                <!--<ResponsiveButton :label="$t('tankOperations.btn.export')" :disabled="!uiPermissions('tankOperationsExportButton').isEnabled" icon="pi pi-file-excel" class="p-button-sm p-button-outlined m-1" @click="printReportExcel"/>
                <ResponsiveButton :label="$t('tankOperations.btn.showTankInfo')" icon="pi pi-database" class="p-button-sm p-button-outlined m-1" @click="showTankInfo = !showTankInfo"/> -->
            </div>
        </div>

        <div class="grid">
            <div class="col-12">
                <GenericDataTable :configuration="configurationGas" :category="'versalis'" :name="'gasGrid'" ref="gasGrid" v-if="filters.family == 'GAS'"/>
                <GenericDataTable :configuration="configurationATZ" :category="'versalis'" :name="'atzGrid'" ref="atzGrid" v-if="filters.family == 'ATZ'"/>
                <GenericDataTable :configuration="configurationBTZ" :category="'versalis'" :name="'btzGrid'" ref="btzGrid" v-if="filters.family == 'BTZ'"/>
            </div>
        </div>

    </main>
</template>